import { Component, inject } from '@angular/core';
import { ResponsiveLayoutService } from '@go-modules/services/responsive-layout/responsive-layout.service';

@Component({
	selector: 'filter-view-layout',
	templateUrl: './filter-view-layout.component.html',
	styleUrls: ['./filter-view-layout.component.scss'],
	standalone: false,
	host: {
		'[class]': 'responsiveLayout.cssClassString()'
	}
})
export class FilterViewLayoutComponent {
	protected responsiveLayout = inject(ResponsiveLayoutService);
}
